import React from 'react';
import { isApp } from 'utils/app';
import useConfig from 'hooks/useConfig';
import { StyledError } from './styles';

/** Error fallback UI component */

function ErrorFallback(props) {
  const {
    general: {
      email,
      phone,
    } = {},
  } = useConfig() || {};
  return (
    <StyledError>
      <pre>Oops!! Something went wrong</pre>
      {
        isApp() ? (
          <pre className="btn">
            You can try closing and reopening the app.
          </pre>
        ) : (
          <pre className="btn">
            Try refreshing your browser
          </pre>
        )
      }
      <pre className="text">
        If you still face issues please reach out to us at
        {' '}
      </pre>

      {phone && <pre className="email">{phone}</pre>}

      {email && <pre className="email">{email}</pre>}
    </StyledError>
  );
}

export default ErrorFallback;
